import { z } from 'zod';

export const MAX_STRENGTHS_PER_NOTE = 3;

export const StrengthTraitSlugSchema = z.enum([
  'light',
  'comfortable',
  'energetic',
  'resourceful',
  'open',
  'calm',
  'charismatic',
  'inspiring',
  'reliable',
  'wise',
  'communicative',
  'unifying',
  'organizer',
  'initiative',
  'conscious',
  'curious',
  'strategic',
  'flexible',
  'creative',
  'systemic',
]);

export type StrengthTraitSlug = z.infer<typeof StrengthTraitSlugSchema>;

export const StrengthTraitSchema = z.object({
  slug: StrengthTraitSlugSchema,
  label: z.string(),
});

export type StrengthTrait = z.infer<typeof StrengthTraitSchema>;

/** Каталог 20 сильных сторон — единый источник для UI и будущего API. */
export const STRENGTH_TRAITS: readonly StrengthTrait[] = [
  { slug: 'light', label: 'Лёгкий' },
  { slug: 'comfortable', label: 'Комфортный' },
  { slug: 'energetic', label: 'Энергичный' },
  { slug: 'resourceful', label: 'Ресурсный' },
  { slug: 'open', label: 'Открытый' },
  { slug: 'calm', label: 'Спокойный' },
  { slug: 'charismatic', label: 'Харизматичный' },
  { slug: 'inspiring', label: 'Вдохновляющий' },
  { slug: 'reliable', label: 'Надёжный' },
  { slug: 'wise', label: 'Мудрый' },
  { slug: 'communicative', label: 'Коммуникабельный' },
  { slug: 'unifying', label: 'Объединяющий' },
  { slug: 'organizer', label: 'Организатор' },
  { slug: 'initiative', label: 'Инициативный' },
  { slug: 'conscious', label: 'Осознанный' },
  { slug: 'curious', label: 'Любознательный' },
  { slug: 'strategic', label: 'Стратегический' },
  { slug: 'flexible', label: 'Гибкий' },
  { slug: 'creative', label: 'Креативный' },
  { slug: 'systemic', label: 'Системный' },
] as const;

export const StrengthTraitSlugListSchema = z
  .array(StrengthTraitSlugSchema)
  .max(MAX_STRENGTHS_PER_NOTE)
  .refine((slugs) => new Set(slugs).size === slugs.length, {
    message: 'Strength slugs must be unique',
  });

export type StrengthTraitSlugList = z.infer<typeof StrengthTraitSlugListSchema>;
